import { useSyncExternalStore } from "react"

import { type PlayerState, coordinator } from "@/lib/player/coordinator"

/**
 * React subscription to the global playback coordinator. Re-renders when
 * `activeId` or `isMuted` change. Components that only care about one slice
 * should derive it with a selector on the returned object to keep renders
 * shallow.
 */
export function usePlayerState(): PlayerState {
  return useSyncExternalStore(
    coordinator.subscribe,
    coordinator.getSnapshot,
    coordinator.getSnapshot,
  )
}
